import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Option', null, { withChildren: true });
